export default {
  article: {
    banners: {
      disableAds: false,
    },
    settings: {
      adultContent: false,
      articleTemplate: 'default',
      contentMarketing: false,
      trending: false,
      customCss: null,
      includeSinglePurchase: true,
      sources: [],
    },
    comments: {
      disableComments: false,
      onlyRegisteredUsersAllowedToComment: false,
    },
    ttsSettings: {
      textToSpeech: '',
      textToSpeechTeaser: '',
    },
    seoFields: {
      seoDescription: null,
      seoTitle: null,
    },
    authors: {
      items: [],
    },
    sources: [
      {
        value: [],
      },
    ],
  },
  headlines: {
    settings: {
      contentMarketing: false,
      trending: false,
    },
    comments: {
      disableComments: false,
      onlyRegisteredUsersAllowedToComment: false,
    },
  },
};
